import includes from 'lodash/includes';

import type { DetectorParams } from '../types';
import { referralAndTextRoutes, seoRoutes } from '../const';

/**
 * Detect the direct channel
 * https://github.com/getjerry/jerry-data-pipeline/blob/main/pipeline/magic/gen_landed_v2.py#L238
 */
export const isDirectChannelFn = ({ utmSource, firstUrl, firstReferer, referrerMedium }: DetectorParams): boolean => {
  if (utmSource) {
    return false;
  }

  if (referralAndTextRoutes.some((v) => includes(firstUrl?.pathname, v))) {
    return false;
  }

  if (firstUrl) {
    if ([...seoRoutes, 'fbclid=', 'gclid='].some((v) => includes(firstUrl?.pathname, v))) {
      return false;
    }
  }

  if (firstReferer) {
    if (firstReferer.indexOf('facebook') !== -1 || firstReferer.indexOf('tiktok') !== -1) {
      return false;
    }

    if (referrerMedium && referrerMedium !== 'internal') {
      return false;
    }
  }

  return true;
};
